import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectStatus = searchParams.get('redirect_status');

    if (redirectStatus === 'succeeded') {
      toast.success('Payment Successful!');
      sessionStorage.removeItem('medicationRequestId');
      setTimeout(() => navigate('/dashboard'), 2000);
    } else if (redirectStatus === 'failed') {
      toast.error('Payment failed. Please try again.');
      setTimeout(() => navigate('/payment'), 2000);
    } else {
      // Handle other statuses or redirect back
      setTimeout(() => navigate('/dashboard'), 1000);
    }
  }, [searchParams, navigate]);

  return (
    <div className="payment-success-container">
      <div className="success-content">
        <div className="spinner"></div>
        <h2>Processing your payment...</h2>
        <p>Please wait while we confirm your payment.</p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
